module.exports = "@page {\n  size: landscape;\n  margin: 0; }\n"